export enum InstrumentFamily {
    Bass = 'bass',
    BrassWoodwind = 'brass_woodwind',
    Drums = 'drums',
    Guitars = 'guitars',
    Keys = 'keys',
    MultiInstrument = 'multi_instrument',
    Percussion = 'percussion',
    PitchedPercussion = 'pitched_percussion',
    FX = 'fx',
    Strings = 'strings',
    Synth = 'synth',
    Vocals = 'vocals',
}
